<!--begin::Sidebar-->
<div id="kt_app_sidebar" class="app-sidebar flex-column" data-kt-drawer="true" data-kt-drawer-name="app-sidebar" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="225px" data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle">
	<!--begin::Logo-->
	<div class="app-sidebar-logo px-4 py-3" id="kt_app_sidebar_logo">
		<!--begin::Logo image-->
		<a routerLink="/dashboard">
			<img alt="Logo" src="/assets/media/logos/default-dark.svg" class="h-55px app-sidebar-logo-default" />
			<img alt="Logo" src="/assets/media/logos/default-small.svg" class="h-40px app-sidebar-logo-minimize" />
		</a>
		<!--end::Logo image-->
		<div id="kt_app_sidebar_toggle" class="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary h-30px w-30px position-absolute top-50 start-100 translate-middle rotate" data-kt-toggle="true" data-kt-toggle-state="active" data-kt-toggle-target="body" data-kt-toggle-name="app-sidebar-minimize">
			<i class="ki-duotone ki-black-left-line fs-3 rotate-180">
				<span class="path1"></span>
				<span class="path2"></span>
			</i>
		</div>
		<!--end::Sidebar toggle-->
	</div>
	<!--end::Logo-->
	<!--begin::sidebar menu-->
	<div class="app-sidebar-menu overflow-hidden flex-column-fluid">
		<!--begin::Menu wrapper-->
		<div id="kt_app_sidebar_menu_wrapper" class="app-sidebar-wrapper">
			<div id="kt_app_sidebar_menu_scroll" class="scroll-y my-5 mx-3" data-kt-scroll="true" data-kt-scroll-activate="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer" data-kt-scroll-wrappers="#kt_app_sidebar_menu" data-kt-scroll-offset="5px" data-kt-scroll-save-state="true">
				<div class="menu menu-column menu-rounded menu-sub-indention fw-semibold fs-6" id="#kt_app_sidebar_menu" data-kt-menu="true" data-kt-menu-expand="true">
					<ng-container *ngFor="let item of menuItems">
						<a *ngIf="item.type === 'single'" [routerLink]="item.link" routerLinkActive="here show" class="menu-item">
							<span class="menu-link">
								<span class="menu-icon">
									<i class="ki-duotone" [ngClass]="item.icon + ' fs-2'">
										<span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span>
									</i>
								</span>
								<span class="menu-title">{{ item.title }}</span>
							</span>
						</a>
						<div *ngIf="item.type === 'accordion'" data-kt-menu-trigger="click" routerLinkActive="here show" [ngClass]="{'menu-item menu-accordion': true,'here show': isActiveRoute(item.basePath)}" class="menu-item menu-accordion">
							<span class="menu-link">
								<span class="menu-icon">
									<i class="ki-duotone" [ngClass]="item.icon + ' fs-2'">
										<span class="path1"></span><span class="path2"></span><span class="path3"></span>
									</i>
								</span>
								<span class="menu-title">{{ item.title }}</span>
								<span class="menu-arrow"></span>
							</span>
							<div class="menu-sub menu-sub-accordion">
								<div class="menu-item" *ngFor="let sub of item.children">
									<!-- If sub has children (3rd level), make it an accordion -->
									<div *ngIf="sub.hasChildren" data-kt-menu-trigger="click" class="menu-item menu-accordion">
										<span class="menu-link">
											<span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
											<span class="menu-title">{{ sub.title }}</span>
											<span class="menu-arrow"></span>
										</span>
										<div class="menu-sub menu-sub-accordion">
											<div class="menu-item" *ngFor="let grandchild of sub.children">
												<a class="menu-link" [routerLink]="grandchild.link" routerLinkActive="active">
													<span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
													<span class="menu-title">{{ grandchild.title }}</span>
												</a>
											</div>
										</div>
									</div>
									<!-- If sub doesn't have children, make it a regular link -->
									<a *ngIf="!sub.hasChildren" class="menu-link" [routerLink]="sub.link" routerLinkActive="active">
										<span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
										<span class="menu-title">{{ sub.title }}</span>
									</a>
								</div>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
		<!--end::Menu wrapper-->
	</div>
	<!--end::sidebar menu-->
</div>
<!--end::Sidebar-->
